module.exports = __webpack_public_path__ + "static/img/5_v2.9811bc16.png";